<template>
  <div class="chart-container">
    <div class="chart">
      <LineChartGenerator
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        class="line-chart"
      />
    </div>
  </div>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement);

export default {
  name: 'BaseLineDiagram',
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    legendPosition: {
      type: String,
      default: 'right',
    },
    chartTitle: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 250,
    },
    maxRangeY: {
      type: Number,
      default: 1000,
    },
    // chartData: {labels: [strings], datasets: [{data[number]}]}
    // labels is an array of strings
    // Example dataSet object, see documentation for more
    // data: [numbers], The number format should in dataSets should be...
    // borderColor: "#000000,
    // backgroundColor: "#ffffff,
    // borderDash: [15, 5] // if using border dash",
    // metadata: "Show this on hover",
    chartData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },
  computed: {
    chartOptions() {
      return {
        locale: 'sv',
        maintainAspectRatio: false,
        hover: {
          mode: 'dataset',
        },
        scales: {
          y: {
            beginAtZero: false,
            type: 'linear',
                min: 0,
                max: this.maxRangeY,
                // suggestedMax: this.maxRangeY,
            grid: {
              display: true,
              // Show horizontal gridline only for every other tick
              color(context) {
                return context.index % 2 == 0 ? '#E5E5E5' : 'transparent';
              },
            },
            ticks: {
              // Remove thousand divider " "
              // callback(value) {
              //   return value;
              // },
              // callback: function(value, index, values) {
              //   // Hide the last label (topmost)
              //   if (index === values.length - 1) {
              //     return '';
              //   } else {
              //     return value;
              //   }
              // }
            },
          },
          x: {
            grid: {
              display: false,
            },
          },
          },
        animation: false,
        plugins: {
          // title: {
          //   display: true,
          //   text: this.chartTitle,
          //   font: {
          //     size: 16,
          //   },
          //   padding: {
          //     bottom: 30,
          //   },
          // },
          legend: {
            display: true,
            position: this.legendPosition,
            title: {
              display: true,
              padding: 10,
            },
            labels: {
              boxHeight: 5,
              boxWidth: 10,
            },
            onHover: this.handleHover,
            onLeave: this.handleLeave,
          },
          tooltip: {
            callbacks: {
              label(context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += new Intl.NumberFormat('sv', { useGrouping: false }).format(
                    context.parsed.y,
                  );
                }
                return label;
              },
            },
            animation: {
              numbers: { duration: 0 },
              colors: {
                type: 'color',
                duration: 100,
                from: 'transparent',
              },
            },
          },
          // Required to avoid memory stack full error
          annotation: {
            annotations: [],
          },
        },
        datasets: {
          line: {
            // Common settings for all lines
            borderWidth: 2,
            hoverBorderWidth: 5,
            pointHitRadius: 10,
          },
        },
      }
    },
  },
  methods: {
    handleHover(evt, item, legend) {
      legend.chart.data.datasets.forEach((ds, index) => {
        ds.borderColor =
          index === item.datasetIndex || ds.borderColor.length === 9
            ? ds.borderColor
            : ds.borderColor + '07';
      });
      legend.chart.update();
    },
    handleLeave(evt, item, legend) {
      legend.chart.data.datasets.forEach((ds) => {
        ds.borderColor = ds.borderColor.length === 9 ? ds.borderColor.slice(0, -2) : ds.borderColor;
      });
      legend.chart.update();
    },
  },
};
</script>

<style scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  padding: 0rem;
  flex-grow: 1;
}
.chart {
  flex-grow: 1;
  overflow: auto;
  position: relative;
  background-color: white;
  overflow: hidden;
}
.line-chart {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 500px;
}
</style>
